import React from "react";

const Crown = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M26 11.825 18 2l-8 9.825-8-4.912v19.65h32V6.913l-8 4.912Zm-3.506 11.88L18 21.072l-4.495 2.633 1.004-5.281-3.782-3.661 5.113-.637L18 9.236l2.16 4.89 5.113.637-3.782 3.66 1.003 5.282ZM2 29.834v3.277h32v-3.277H2Z"
            fill={fill}
        />
    </svg>
);

export default Crown;
